import React, { useEffect, useState, useContext, useCallback } from "react";
import { AutoComplete, Form, Input, Row, Col } from "antd";
import { getInvestigationsSearchApi } from "../../../../services/investigation.services";
import { getCookie } from "../../../../helpers/localStorage";
import { FacilityID, Role } from "../../../../constants/defaultKeys";
import { UserContext } from "../../../../context/UserContext";
import { debounce } from "../../../../helpers/utility";
import { SearchOutlined } from "@ant-design/icons";
import inputStyles from "../../../../styles/Custom/Input.module.css";

const InvestigationSearchList = ({ field, form }) => {
  const { userDetails } = useContext(UserContext);

  const [options, setOptions] = useState([]);

  // 🔥 This is the MOST IMPORTANT PART
  // Maintain state per row
  const [selectedName, setSelectedName] = useState("");
  const [selectedInvestigationId, setSelectedInvestigationId] = useState(null);

  // Load prepopulated values
  useEffect(() => {
    const existing = form.getFieldValue(["investigations", field.name]);

    if (existing) {
      setSelectedName(existing.name || "");
      setSelectedInvestigationId(existing.investigation_id || null);
    }
  }, []);

  // Sync state → form ALWAYS
  useEffect(() => {
    if (selectedName) {
      form.setFieldValue(["investigations", field.name, "name"], selectedName);
    }

    if (selectedInvestigationId !== null) {
      form.setFieldValue(
        ["investigations", field.name, "investigation_id"],
        selectedInvestigationId
      );
    }
  }, [selectedName, selectedInvestigationId]);

  const handleSearch = (val) => {
    if (!val) return;

    const facility = getCookie(FacilityID) || userDetails?.currFacility;

    getInvestigationsSearchApi(`${val.toLowerCase()}&facility_id=${facility}`)
      .then((res) => {
        setOptions(
          res.data.map((item) => ({
            value: item.name,
            id: item.investigation_id,
            label: (
              <Row>
                <Col span={24}>{item.name}</Col>
              </Row>
            ),
          }))
        );
      })
      .catch((err) => console.log(err));
  };

  const debouncedSearch = useCallback(debounce(handleSearch, 300), []);

  const defaultRole = getCookie(Role) || userDetails?.currRole;

  return (
    <>
      <Form.Item name={[field.name, "name"]} label="Name">
        <AutoComplete
          value={selectedName}
          options={options}
          disabled={["Nurse", "Receptionist"].includes(defaultRole)}
          onSearch={debouncedSearch}
          onChange={(val) => setSelectedName(val)}
          onSelect={(value, option) => {
            // 🔥 Replace BOTH name and investigation_id
            setSelectedName(option.value);
            setSelectedInvestigationId(option.id);
          }}
        >
          <Input
            size="large"
            prefix={<SearchOutlined />}
            placeholder="Search Investigations"
            className={inputStyles.mdInput}
          />
        </AutoComplete>
      </Form.Item>

      {/* Hidden ID fields */}
      <Form.Item name={[field.name, "investigation_id"]} hidden>
        <Input />
      </Form.Item>
      <Form.Item name={[field.name, "id"]} hidden>
        <Input />
      </Form.Item>
    </>
  );
};

export default InvestigationSearchList;
